import { addScript } from '../../scripts';
import type { EventKey, TagConfig, TrackOpts } from './types';

const events: Record<EventKey, string> = {
  APPLICATION_SUBMIT: 'SubmitFoundersHub',
};

const defaultPartnerId = '1770559986549030';

interface Fbq {
  (event: string, data: string, other?: unknown): void;
  callMethod?: (event: string, data: string, other?: unknown) => void;
  push: Fbq;
  queue: Array<[event: string, data: string, other?: unknown]>;
  loaded: boolean;
  version: string;
}

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
    GPC_DataSharingOptIn: boolean;
  }
}

export function init({ partnerId = defaultPartnerId, consent }: TagConfig) {
  if (window.fbq || !(consent.Advertising && consent.Analytics) || !window.GPC_DataSharingOptIn) {
    return;
  }

  const fbq = <Fbq>function (...args) {
    // The pixel does not work with .call() only .apply() ¯\_(ツ)_/¯
    // eslint-disable-next-line prefer-spread
    fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
  };
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];

  window._fbq = fbq;
  window.fbq = fbq;

  addScript({
    src: 'https://connect.facebook.net/en_US/fbevents.js',
    crossOrigin: false,
  });

  updateConsent(consent.Advertising && consent.Analytics);
  fbq('init', partnerId);
  fbq('track', 'PageView');
}

function updateConsent(grant: boolean) {
  if (window.fbq) {
    window.fbq('consent', grant ? 'grant' : 'revoke');
  }
}

export function track({ event, consent }: TrackOpts) {
  if (!window.GPC_DataSharingOptIn) {
    return;
  }

  updateConsent(consent.Advertising && consent.Analytics);

  if (window.fbq && consent.Advertising && consent.Analytics) {
    window.fbq('trackCustom', events[event]);
  }
}
